import { render, staticRenderFns } from "./AccessoryTechnicalFeatures.vue?vue&type=template&id=5da5e022&"
import script from "./AccessoryTechnicalFeatures.vue?vue&type=script&lang=js&"
export * from "./AccessoryTechnicalFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5da5e022')) {
      api.createRecord('5da5e022', component.options)
    } else {
      api.reload('5da5e022', component.options)
    }
    module.hot.accept("./AccessoryTechnicalFeatures.vue?vue&type=template&id=5da5e022&", function () {
      api.rerender('5da5e022', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/accessories/AccessoryTechnicalFeatures.vue"
export default component.exports